/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteSet.defs.js'
export * as $defs from './deleteSet.defs.js'
